import s from './index.module.scss';

export const ProgressBar = ({ percent }) => {
  return (
    <div className={s.wrapper}>
      <div className={s.percent}>{percent}%</div>
      <div className={s.line_yellow} style={{ width: `${percent}%` }} />
    </div>
  );
};
